import { Col, Row } from "antd";
import { Button, InputText, Modal, StandardTable } from "react3l-ui-library";
import { useMenuReportPreviewHook } from "./MenuReportPreviewHook";
import Close16 from "@carbon/icons-react/es/close/16";
import Download16 from "@carbon/icons-react/es/download/16";
import { formatDateTime } from "helpers/date-time";
import { utilService } from "services/common-services/util-service";
import { Close20 } from "@carbon/icons-react";
import React from "react";
import { MODAL_SIZE } from "react3l-ui-library/build/components/Modal/Modal";

export function MenuReportPreview() {
  const {
    translate,
    handleGoMaster,
    handleCloseTemplateInputModal,
    variablesFileDownloadPath,
    model,
    columns,
    columnFileTemplateInputs,
    visibleFileTemplateInputModal,
    currentFileTemplateInputs,
  } = useMenuReportPreviewHook();
  return (
    <>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-component ml-4 mb-3">
          <span>{translate("menuReports.master.header")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("menuReports.master.subHeader")}
          </span>
        </div>

        <div className="page page-detail p-t--lg p-l--xxl p-b--lg">
          <div className="mb-0 d-flex justify-content-between background-w-dxg border-tl-8-dxg">
            <h5 className="font-bold page-title">
              {translate("menuReports.master.subHeader")}
            </h5>
            <div className="mr-3">
              <Button
                type="secondary"
                className="btn--lg btn-red"
                icon={<Close16 />}
                onClick={handleGoMaster}
              >
                {translate("general.actions.close")}
              </Button>
            </div>
          </div>

          <div className="page-detail__title p-b--lg">
            {translate("general.detail.title")}
          </div>
          <Row>
            <Col span={6} className="p-r--sm">
              <div className="p-t--xxs">
                <div className="page-detail__title general-field__first-row">
                  <span>{translate("menuReports.site")}</span>
                </div>
                <div className="general-field__second-row p-t--xxs">
                  {/*<span>{model?.site?.name}</span>*/}
                  <InputText
                    type={0}
                    value={model?.site?.name}
                    disabled
                    className="btn-black-preview"
                  />
                </div>
              </div>
            </Col>
            <Col span={6} className="p-r--sm">
              <div className="p-t--xxs">
                <div className="page-detail__title general-field__first-row">
                  <span>{translate("menuReports.menu")}</span>
                </div>
                <div className="general-field__second-row p-t--xxs">
                  {/*<span>{model?.menu?.name}</span>*/}
                  <InputText
                    type={0}
                    value={model?.menu?.name}
                    disabled
                    className="btn-black-preview"
                  />
                </div>
              </div>
            </Col>
            <Col span={6} className="p-r--sm">
              <div className="p-t--xxs">
                <div className="page-detail__title general-field__first-row">
                  <span>{translate("menuReports.name")}</span>
                </div>
                <div className="general-field__second-row p-t--xxs">
                  {/*<span>{model?.name}</span>*/}
                  <InputText
                    type={0}
                    value={model?.name}
                    disabled
                    className="btn-black-preview"
                  />
                </div>
              </div>
            </Col>
            <Col span={6} className="p-r--sm p-t--sm">
              <Button
                type="outline-primary"
                className="btn--lg"
                icon={<Download16 />}
                onClick={() => {
                  utilService.downloadURI(
                    variablesFileDownloadPath,
                    "fileName"
                  );
                }}
              >
                {translate("menuReports.exportVariables")}
              </Button>
            </Col>
            <Col span={6} className="p-r--sm p-t--sm">
              <div className="p-t--xxs">
                <div className="page-detail__title general-field__first-row">
                  <span>{translate("menuReports.createdAt")}</span>
                </div>
                <div className="general-field__second-row p-t--xxs">
                  {/*<span>{formatDateTime(model?.createdAt)}</span>*/}
                  <InputText
                    type={0}
                    value={formatDateTime(model?.createdAt)}
                    disabled
                    className="btn-black-preview"
                  />
                </div>
              </div>
            </Col>
            <Col span={6} className="p-r--sm p-t--sm">
              <div className="p-t--xxs">
                <div className="page-detail__title general-field__first-row">
                  <span>{translate("menuReports.updatedAt")}</span>
                </div>
                <div className="general-field__second-row p-t--xxs">
                  {/*<span>{formatDateTime(model?.updatedAt)}</span>*/}
                  <InputText
                    type={0}
                    value={formatDateTime(model?.updatedAt)}
                    disabled
                    className="btn-black-preview"
                  />
                </div>
              </div>
            </Col>
            <Col span={6} className="p-r--sm p-t--sm">
              <div className="p-t--xxs">
                <div className="page-detail__title general-field__first-row">
                  <span>{translate("menuReports.modifier")}</span>
                </div>
                <div className="general-field__second-row p-t--xxs">
                  {/*<span>{model?.modifier?.displayName}</span>*/}
                  <InputText
                    type={0}
                    value={model?.modifier?.displayName}
                    disabled
                    className="btn-black-preview"
                  />
                </div>
              </div>
            </Col>
          </Row>
          <div className="m-b--lg m-t--sm">
            <StandardTable
              columns={columns}
              dataSource={model.fileTemplates}
              rowKey={"id"}
              pagination={false}
              tableSize="lg"
              isDragable={true}
              scroll={{ x: 1000, y: 500 }}
            />
          </div>
        </div>
      </div>
      <Modal
        size={MODAL_SIZE.SIZE_1200}
        visibleFooter={false}
        visible={visibleFileTemplateInputModal}
        handleCancel={handleCloseTemplateInputModal}
        title={translate("fileTemplates.fileTemplateInputs.title")}
        titleButtonCancel={translate("general.actions.close")}
        titleButtonApply={translate("general.actions.save")}
        closable={false}
        wrapClassName={"dxg-modal-wrap"}
      >
        <div className="modal-content">
          <div className="m-t--sm">
            <div className="w-100">
              <StandardTable
                rowKey={"id"}
                columns={columnFileTemplateInputs}
                dataSource={currentFileTemplateInputs}
                tableSize={"lg"}
                bordered
              />
            </div>
          </div>
        </div>

        <span className={"close-modal"} onClick={handleCloseTemplateInputModal}>
          <Close20 />
        </span>
      </Modal>
    </>
  );
}
